/* eslint-disable react/prop-types */
import { useState } from 'react';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import TechinicalTeamForm from '../TechinicalTeamForm ';
import { deleteTechnicalTeam } from '../../service/technicalTeam.service';

const TechnicalTeamTableList = ({ listItem, title, mutate }) => {
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [team, setTeam] = useState(null);
  const [id, setId] = useState('');
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });

  const deleteFunc = () => {
    deleteTechnicalTeam(id);
    mutate()
  };

  const handleDelete = (idItem, valueItem) => {
    setDialog({
      msg: `Tem certeza que deseja remover ${valueItem}?`,
      title: `Remover ${valueItem} da tabela ${title}`,
    });
    setId(idItem);
    setOpenConfirm(true);
  };

  const handleEdit = async (item) => {
    await setTeam(item);
    setOpen(true);
  };

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
        next={deleteFunc}
      />
      <TechinicalTeamForm open={open} setOpen={setOpen} title={title} techinicalTeam={team} mutate={mutate} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="70%">Descrição</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem !== null &&
              listItem.map((item) => (
                <TableRow key={item.id}>
                  <TableCell align="left">{item.id}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => handleEdit(item)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(item.id, item.name)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

TechnicalTeamTableList.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      description: P.string,
    })
  ),
  title: P.string.isRequired,
};

TechnicalTeamTableList.defaultProps = {
  listItem: null,
};

export default TechnicalTeamTableList;
